export default __webpack_public_path__ + "static/media/b0c5babd8bffc9e4b60e965a266075b21581600837357.6bc33cf6.webp";